import { createLegacyModule } from "./createLegacyModule";

const keys = [
  "Cancel",
  "Confirm",
  "Check code",
  "Enter a correct Phone Number",
  "No more data",
  "No order at present",
  "After the meal pay",
  "app All",
  "app Pending payment",
  "arrived",
  "Can earn the amount of points",
  "cancellation of order",
  "Cash on delivery",
  "Choosing the Time of Service",
  "Contact person",
  "Coupon",
  "Delivered at TIME",
  "Delivery In Progress",
  "Delivery Man Reached Destination Nearby",
  "Delivery Man Reached Pickup Point",
  "Delivery Man Reached Pickup Point Nearby",
  "Delivery phone",
  "Deliveryman",
  "Discounted price",
  "Dispatching",
  "Enter your promo code",
  "Expected",
  "Expected to arrive at TIME",
  "Expected to take orders at TIME",
  "Freight",
  "Have discount",
  "In_production",
  "Invite details",
  "Lunch box fee",
  "Meal code",
  "Merchant has received an order",
  "Name of restaurant",
  "No order at present",
  "Once you close the page, you will lose order details as you are not login. Please login account or use screenshot to save details.",
  "Online payment",
  "Order Assigned To Another Delivery Man",
  "Order Assigned To Delivery Man",
  "Order confirmed",
  "Order Created",
  "Order Delivered",
  "Order delivery",
  "Order details",
  "Order No",
  "Order notes",
  "Order submitted",
  "order time",
  "Order tracking",
  "Outgoing details",
  "Pay here",
  "Payment error, please use other ways to pay first!",
  "Payment me",
  "Payment method",
  "Please contact the staff for the check code",
  "Please choose the time of service",
  "Incorrect check code, please enter again",
  "Please pay at the counter, thank you!",
  "Please pay at the couter and get your meal.",
  "Please show your number to pick up the meal and you can refresh the page for latest status.",
  "Reason for Cancellation",
  "Receiving address",
  "Service time",
  "Shortcut label",
  "Solitary time",
  "submitted",
  "Take food information",
  "Taken_meals",
  "Tel",
  "The driver is taking food",
  "The order has been cancelled",
  "The shop does not support the choice of delivery time",
  "The store to pay",
  "To be evaluated / voted",
  "To_pay",
  "topTitleText",
  "Total Amount",
  "Total_service",
  "UnOrder",
  "Waiting for meal",
  "Welcome for next visit!",
  "You have picked up your meal.",
  "You have to cancel"
];

const legacyOrderMessages = createLegacyModule(keys);

// * 補充訂單列表專用翻譯，避免與品牌團購促銷文案混用
export default {
  en: {
    ...legacyOrderMessages.en,
    Group_purchase_coupon: "Group buy voucher",
  },
  cn: {
    ...legacyOrderMessages.cn,
    Group_purchase_coupon: "团购券",
  },
  hk: {
    ...legacyOrderMessages.hk,
    Group_purchase_coupon: "團購券",
  },
};
